import React, { FunctionComponent } from 'react'

import { PricingFormattedPrice } from './pricingFormatters'

interface PlansTablePriceProps {
  price: PricingFormattedPrice
}

const PlansTablePrice: FunctionComponent<PlansTablePriceProps> = ({
  price,
}) => (
  <p className='PlansTable-price-value'>
    {price.currencyLast ? `` : price.currency}
    {price.integer.length ? price.integer.join(``) : ``}
    <sup>{price.fraction.length ? price.fraction.join(``) : ``}</sup>
    {price.currencyLast ? price.currency : ``}
  </p>
)

export default PlansTablePrice
